import { render, staticRenderFns } from "./TemplateContentTile.vue?vue&type=template&id=3fb927a1&scoped=true&"
import script from "./TemplateContentTile.vue?vue&type=script&lang=ts&"
export * from "./TemplateContentTile.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateContentTile.vue?vue&type=style&index=0&id=3fb927a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb927a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
